export class BibliographyWorkParent {
  constructor() {
    this.list = []
  }

  addBibliographyWork(item) {
    this.list.push(BibliographyWork.buildFromAPI(item))
  }

  updateBibliographyWork(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    this.list.splice(index, 1, BibliographyWork.buildFromAPI(item))
  }

  removeBibliographyWork(id) {
    const index = this.list.findIndex(el => el.id === id)
    this.list.splice(index, 1)
  }

  getForAPI(isVac = false) {
    return this.list.map(el => el.getForAPI(isVac))
  }

  buildFromAPI(obj) {
    if (obj) {
      this.list = obj.map(el => BibliographyWork.buildFromAPI(el))
    }
    return this
  }
}

export class BibliographyWork {
  constructor() {
    this.id = null
    this.vac = null
    this.link = null
    this.citationCount = null
    this.bibliography = null
    this.commonWork = null
  }

  getForAPI(isVac) {
    return {
      id: this.id,
      vac: this.vac || isVac,
      link: this.link,
      citationCount: this.citationCount,
      bibliography: this.bibliography,
      commonWork: this.commonWork
    }
  }

  static buildFromAPI(obj) {
    const _this = new BibliographyWork()
    if (obj) {
      _this.id = obj.id
      _this.vac = obj.vac
      _this.link = obj.link
      _this.citationCount = obj.citationCount
      _this.bibliography = obj.bibliography
      _this.commonWork = obj.commonWork
    }
    return _this
  }
}
